import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { getPostTypeString } from '../../../../utils';
import { marketCategories } from '../../../../utils/market';
import { SEARCH_PAGE_LINK } from '../../../../utils/routes';
import MenuContainer from './CategoryDropdown';
import InputWithButton from './InputWithButton';
import SearchSuggestions from './SearchSuggestions';

const MdOutlineArrowRightAlt = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdOutlineArrowRightAlt)
);

const SearchField = ({ withoutPostType = false, isRounded = false }) => {
  const lang = useSelector(({ common }) => common?.language);
  const router = useRouter();
  const { city } = router.query;
  const [searchText, setSearchText] = useState('');
  const [showPopover, setShowPopover] = useState(false);
  const [selectedPostType, setSelectedPostType] = useState(null);
  const moduleName = getPostTypeString(router.pathname);
  const searchSuggestions = useSelector(({ market }) => {
    return market?.searchSuggestions;
  });
  const [isHovering, setIsHovering] = useState(false);

  const searchPageLink = SEARCH_PAGE_LINK({
    moduleName,
    postTypeId: selectedPostType?.id,
    searchText,
    city,
  });

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <div className={`relative `}>
      <div
        className={`flex items-center border border-[#ebebeb] bg-white ${
          isRounded ? 'h-[45px] rounded-[100px]' : ''
        } `}
      >
        {withoutPostType && lang ? null : (
          <MenuContainer
            className='text-[14px]'
            label={lang?.common?.all}
            setSelected={setSelectedPostType}
            menus={[
              {
                id: null,
                name: lang?.common?.all,
              },
              ...marketCategories(lang).filter((item) => item.id !== 'for_you'),
            ]}
          />
        )}
        <InputWithButton
          placeholder={
            isRounded ? lang?.common?.search_by : lang?.common?.search_by_market
          }
          isRounded={isRounded}
          searchText={searchText}
          setSearchText={setSearchText}
          withPostType={true}
          postType={selectedPostType}
          setShowPopover={setShowPopover}
          isHovering={isHovering}
        />
      </div>

      {showPopover && searchSuggestions && searchSuggestions.length !== 0 && (
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className={`absolute z-[99] ${
            isRounded ? 'top-[43px]' : 'top-[50px]'
          }  left-0 w-full border bg-white`}
        >
          {searchSuggestions?.data?.length > 0 ? (
            <>
              <SearchSuggestions
                searchSuggestions={searchSuggestions}
                setShowPopover={setShowPopover}
              />
              <Link href={searchPageLink}>
                <button
                  onClick={() => {
                    setShowPopover(false);
                  }}
                  className='mb-0 flex w-full items-center justify-center gap-1 bg-[#F6F6F6]  px-[12px] py-2 font-bold text-black'
                >
                  {lang?.common?.see_all_results}
                  <MdOutlineArrowRightAlt className='mt-1 text-[22px] font-bold' />
                </button>
              </Link>
            </>
          ) : (
            searchText && (
              <p className='mb-0 flex justify-center bg-[#F6F6F6] px-[12px] py-2 font-bold'>
                {lang?.common?.no_results_found}
              </p>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default SearchField;
